import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { DeactivateSubscriptionBatchInput } from '../domain/dtos/deactivate-subscription-batch-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class DeactivateSubscriptionBatch {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(data: DeactivateSubscriptionBatchInput): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.makeUrl(),
      body: this.makeBody(data),
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data
    } else {
      /** @todo: Handle backend errors */
      throw new GeneralError()
    }
  }

  private makeBody(data: DeactivateSubscriptionBatchInput): DeactivateSubscriptionBatchInput {
    return data
  }

  private makeUrl() {
    return `${Envs.BFF_WEB_URL}/subscriptions/batch/deactivate`
  }
}
